
import React, { useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import { ArticleGet } from '../../api/orgService';
import { toast } from 'react-toastify';
import useApi from '../../api/useApi';
import { Link } from 'react-router';


const newsItems = [
  {
      "id": 6,
      "title": "Airtel Kenya and Fountain Africa Trust Launch Community Midwifery Program",
      "img": "https://file.fountainafrica.org/wp-content/uploads/2025/11/4-768x420.jpg",
      "description": "Bharti Airtel, a leading telecommunications services provider with over 300 million customers and operations in 20 countries across Africa and Asia has partnered with Fountain Africa Trust to launch a community midwives program to support expectant women, new mothers and newborns in Bungoma County. The program that will be launched in June 2015 and it will offer free calling and sms services to 57 midwives and staff from Fountain Africa Trust to enable sharing of information and learning experiences between Bungoma County mothers and the County ministry of health officials as they go on with their program of supporting expectant women, new mothers and newborns.      Airtel will also offer 24 hour free internet connectivity for the Fountain Africa Trust, giving them unlimited access to online information that will help them carry out their program effectively and interact with other midwives across the globe. In a statement issued on 25th May 2015, Airtel Kenya CEO Adil El Youssefi said that by enabling the midwives to communicate effectively, especially in emergency cases, the company is helping the government attain its Millennium Development Goals (MDGs) 4 and 5.    “Airtel is intensely interested in the health and general wellbeing of pregnant women and infants. We believe that by providing effective communication solutions to the midwives from this group, we will be giving thousands of mothers from Bungoma County a chance to experience the joy of motherhood,”  added Mr. El Youssefi.   On her part, Fountain Africa Trust Executive Director, Ms. Alice Natecho, said “Despite significant improvements in maternal and newborn care services in Bungoma County, recent findings from the Kenya Demographic and Health Survey 2014 show that the proportion of deliveries conducted by a skilled provider in the county is 41.4% while the proportion of women who delivered in health facilities is 40.8%.” She added that “Fountain Africa Trust is working closely with the County and sub-County Ministry of Health teams to support community midwives to improve the provision of services such as prenatal care, delivery, postnatal care, family planning as well as referral services among other key roles played by community midwives.”",
  },
  {
      "id": 3,
      "title": "Implementation Research on Health Facility Quality Improvement Teams",
      "img": "https://file.fountainafrica.org/wp-content/uploads/2025/11/Implementation%20Research%20on%20Health%20F%20Img.jpg",
      "description": "Although most Health Facilities provide services in accordance with the Kenya Essential Package for Health (KEPH) by level of care, most counties exhibit major gaps in the provision of newborn care. Nearly all counties have a quality of care strategy, committees and implementing units in place, with coordinators at the county level and structures at sub-county level. However, the quality of care committees and implementing units are not functional.  In this study, we seek to use implementation research (IR) to test the feasibility of operationalizing QITs and make them functional with a view to increasing access to quality healthcare services for sick young infants in Bungoma County. The IR study commences in February 2020 and is expected to be concluded after 9 months.",
  },
  {
      "id": 5,
      "title": "Newborn Health - Collaborative Newborn Support Project",
      "img": "https://file.fountainafrica.org/wp-content/uploads/2025/11/Newborn-Health%20img.jpg",
      "description": "Newborn babies in Bungoma County are now assured of quality specialized care, thanks to the launch of an upgraded new-born care unit at Webuye County Referral Hospital in Bungoma County. The new-born care unit was officially launched today by His Excellency the President, Honourable Uhuru Kenyatta, who was accompanied by Bungoma County Governor, H.E. Mr Kenneth Lusaka, County Executive Committee Member for Health Mr. Stephen Kokonya, Mount Kenya University Vice Chancellor Prof. Stanley Waudo and Fountain Africa Trust Director Ms. Alice Natecho. The launch was hosted by the Bungoma County Ministry of Health in collaboration with the Collaborative New Born Support Project. The goal of the Collaborative New Born Support project is to reduce the high neonatal deaths in Bungoma County, which is among the highest in Kenya, by 30% between October 2015 and September 2017. Speaking during the launch of the upgraded new-born unit at Webuye County Referral Hospital, the President reiterated the Government’s manifesto and pledged to ensure that newborns and their mothers receive quality and supportive services with a view to safeguarding both the mother and child. Dr. Jesse Gitaka, the project team leader, informed the President that the project has so far accomplished the following milestones: •\tSet up new born units in 3 hospitals, including the one at Webuye Hospital being launched •\tEstablished a call centre through which calls are made to mothers who have been discharged from hospital to monitor the well-being of both the mother and baby •\tHeld community level sensitization meetings to increase demand for new born care services with support from Sub-County Commissioners and Chiefs •\tCarried out public advocacy on new born care through local FM radio programmes, and •\tEstablished the tele-health platform through which healthcare workers provide specialized care to newborns with support from peadiatricians based outside the County. On his part, the Bungoma County Governor thanked the people of the United Kingdom for their contribution towards the survival of newborns in Bungoma County .",
  }]


function ArticleStoriesSection() {

  const [articles, setArticles] = useState(newsItems)
  const { request: getAllArticles, data:articleData, error:articleError} = useApi(ArticleGet);
    
  useEffect(() => {
    getAllArticles();
         // eslint-disable-next-line
    }, []);
    
    useEffect(()=>{
      if (articleData?.status===200) {
        setArticles(articleData?.data?.results);
      }
    // eslint-disable-next-line
    },[articleData])

  
    // useEffect(()=>{
    //     if(location?.state?.refresh==="org"){
    //       getAllArticles();
    //     }
    //   // eslint-disable-next-line
    //   },[location?.state])
  
    useEffect(()=>{
        if(articleError){
            toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[articleError]) 

    
    const carouselRef = useRef(null);
    const [scrollProgress, setScrollProgress] = useState(0);
    

    const handleScroll = () => {
      const carousel = carouselRef.current;
      if (carousel) {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        const progress = (carousel.scrollLeft / maxScroll) * 100;
        setScrollProgress(progress);
      }
    };

    const scrollNext = () => {
      const carousel = carouselRef.current;
      if (carousel) {
        carousel.scrollBy({ left: 350, behavior: "smooth" });
      }
    };

    const scrollPrev = () => {
      const carousel = carouselRef.current;
      if (carousel) {
        carousel.scrollBy({ left: -350, behavior: "smooth" });
      }
    };

    useEffect(() => {
      const carousel = carouselRef.current;
      if (carousel) {
        carousel.addEventListener("scroll", handleScroll);
        return () => carousel.removeEventListener("scroll", handleScroll);
      }
    }, []);


  return (
    <section className="news-news-carousel" >
      <h2 className="section-title">Our Stories and Articles</h2>
      <div className="news-carousel-container" ref={carouselRef}>
        <div className="news-carousel-news">
          {articles?.map((item, index) => (
            <article className="news-news-card" key={index}>
              <div className="news-image-wrapper">
                <img src={item.img} alt={item.title} />
                <div className="news-icon">{item?.icon}</div>
              </div>
              <div className="news-content-news">
                <h3>{item.title}</h3>
                <p>{item.description.slice(0,300)}</p>
                <div className="news-stats">
                  {/* {item.stats.map((s, i) => (
                    <div className="news-stat-box" key={i}>
                      <h4>{s.value}</h4>
                      <p>{s.label}</p>
                    </div>
                  ))} */}
                </div>
                {/* /articles/:article_title/:id/ */}

                <Link
                  to={`/articles/${item?.title?.slice(0,20)}/${item?.id}/`}
                  state={{ articleId: item?.id, articleName: item?.title
                    // ,subcategory: projects[activeIndex]?.subcategory
                  }}
                >
                  Learn More →
                </Link>
                {/* <a href={item?.link} className="news-learn-more">
                  Learn More →
                </a> */}
              </div>
            </article>
          ))}
        </div>
      </div>
      {/* Carousel Controls */}
      <div className="news-carousel-controls">
        <button className="news-control-btn" onClick={scrollPrev}>
          ◀ 
        </button>

        <button className="news-control-btn" onClick={scrollNext}>
          ▶
        </button>
        <div className="news-progress-bar">
          <div
            className="news-progress-fill"
            style={{ width: `${scrollProgress}%` }}
          ></div>
        </div>
      </div>
    </section>

  )
}

export default ArticleStoriesSection